'use strict';

var UA = typeof navigator !== 'undefined' && navigator ? navigator.userAgent || '' : '';

var cache = {};

// Ugly, simple but works
var REGEX_SIMPLE_VERSION = /^[\d\.]+$/;

var BROWSER = {
  weixin: {
    // The userAgent of weixin dev tool might be `MicroMessenger/undefined`
    regex: /MicroMessenger\/(\S+)/i,
    index: function index(m) {
      return m[1];
    }
  },

  android: {
    regex: /Android\s+([\d.]+)/i,
    index: function index(m) {
      return m[1];
    }
  },

  ios: {
    regex: /.*OS\s([\d_]+)/i,
    index: function index(m) {
      return m[1];
    }
  },

  app: {
    regex: /BEAST\/(\d+\.\d+\.\d+)/,
    index: function index(m) {
      return m[1];
    }
  }
};

var browser = module.exports = {};

Object.keys(BROWSER).forEach(function (type) {
  var origin = BROWSER[type];

  browser[type] = function (_ua) {
    if (!_ua && type in cache) {
      return cache[type];
    }

    var ua = arguments.length ? _ua : UA;

    if (!ua) {
      return false;
    }

    var matched = ua.match(origin.regex);
    var version = matched && origin.index(matched);

    var result = !version ? false : {
      version: version
    };

    if (!_ua) {
      cache[type] = result;
    }

    return result;
  };
});

browser['uniapp'] = isUni;
function isUni() {
  if (window) {
    return UA.indexOf('uni-app') > -1;
  }
  return false;
}

function get_numeric_number(str) {
  var version = str.replace(/_/g, '.').split('.').slice(0, 2).map(function (x) {
    return Number(x) || 0;
  }).join('.');

  return Number(version) || 0;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/browser/lib/index.js
// module id = 936
// module chunks = 0